import React, { useEffect } from "react";

import { ExpressEnrollmentStyledForm } from "./components";

export function ApplicationForm({ form, onErrors, formId, initialValues, isFormDisabled, children }) {
  useEffect(() => {
    form.validateFields();
    form.setFieldsValue({ form_disabled: isFormDisabled });
  }, [isFormDisabled]);

  return (
    <ExpressEnrollmentStyledForm
      id={formId}
      form={form}
      onFieldsChange={(changedFields, allFields) => {
        const errors = allFields.filter((field) => field.errors.length);
        if (errors) {
          onErrors(errors);
        }
      }}
      layout="vertical"
      name={formId}
      initialValues={{ ...initialValues, form_disabled: isFormDisabled }}
      disabled={isFormDisabled}
    >
      {children}
    </ExpressEnrollmentStyledForm>
  );
}
